import { Component, OnInit } from '@angular/core';
import { HomePageService } from '../homepage.service';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.css']
})
export class CancellationPolicyComponent implements OnInit {
  cancellationPolicy: string;

  constructor(private homePageService: HomePageService) { }

  ngOnInit(): void {
    this.getTermsAndPrivacyData();
  }

  getTermsAndPrivacyData() {
    this.homePageService.termConditionAndPrivacyPolicy().subscribe((data: any) => {
      // this.termsAndConditions = data.termAndPrivacyData.termCondition;
      // this.privacyPolicy = data.termAndPrivacyData.privacyPolicy;
      this.cancellationPolicy = data.termAndPrivacyData.cancellationPolicy;
    });
  }

}
